import { ExpandMore, History } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Alert, Box, Typography } from "@mui/material";
import { EdmButton } from "atoms";
import { Page } from "organisms";
import { ErrorInfo } from "react";
import { useResetErrorBoundaryOnLocationChange, useTranslate } from "react-admin";

import EdmLayout from "./EdmLayout";

export default function EdmError({
  error,
  resetErrorBoundary,
  errorInfo,
}: {
  errorInfo?: ErrorInfo | undefined;
  error: Error;
  resetErrorBoundary: (args?: unknown) => void;
}) {
  useResetErrorBoundaryOnLocationChange(resetErrorBoundary);

  return (
    <EdmLayout>
      <ErrorPageContent error={error} errorInfo={errorInfo} />
    </EdmLayout>
  );
}

export function ErrorPageContent({ error, errorInfo }: { errorInfo?: ErrorInfo | undefined; error?: Error }) {
  const translate = useTranslate();
  return (
    <Page>
      <Box display="flex" alignItems="center" gap={2} mb={4}>
        <Typography variant="h5" component="h1">
          {translate("ra.page.error")}
        </Typography>
      </Box>
      <Alert severity="error" sx={{ maxWidth: "60em", mb: 4 }}>
        {translate("hints.error_info")}
      </Alert>

      {process.env.NODE_ENV !== "production" && error && (
        <Box sx={{ maxWidth: "60em" }}>
          <Typography mb={2}>Fehlermeldung:</Typography>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMore />}>
              {translate(error.message, {
                _: error.message,
              })}
            </AccordionSummary>
            <AccordionDetails>
              <p>
                {translate(error.message, {
                  _: error.message,
                })}
              </p>
              <p>{errorInfo?.componentStack}</p>
            </AccordionDetails>
          </Accordion>
        </Box>
      )}

      <EdmButton onClick={() => history.go(-1)} label={translate("ra.action.back")} sx={{ mt: 4 }}>
        <History />
      </EdmButton>
    </Page>
  );
}
